import React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

const CustomSeo = ({ title = null, description = null, image = null, customTitle = false }) => {
  const { pathname } = useLocation()
  const { site, wp } = useStaticQuery(query)

  const {
    siteUrl,
    defaultImage,
    twitterUsername,
  } = site.siteMetadata

  let seoTitle = customTitle || title;
  seoTitle = seoTitle.toLowerCase().includes('lenco supplies') ? seoTitle : seoTitle + ' - ' + wp.meta.title;

  const seo = {
    title: seoTitle,
    description: description || wp.meta.description,
    image: image || defaultImage,
    url: `${siteUrl}${pathname}`,
  }

  return (
    <Helmet title={seo.title}>
      <meta name="description" content={seo.description} />

      <meta name="image" content={seo.image} />

      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content={wp.meta.title} />
      <meta property="og:type" content="website" />

      {seo.url && <meta property="og:url" content={seo.url} />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      {seo.image && <meta property="og:image" content={seo.image} />}
      {seo.image && <meta property="og:image:secure_url" content={seo.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.image} />}

    </Helmet>
  )
}

export default CustomSeo

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        siteUrl
        image
      }
    }
    wp {
      meta: generalSettings {
        description
        title
      }
    }
  }
`
